<body class="body-form-signin forbidden-bg"
      [style]="whitelabel ? 'background-image: url(' + whitelabelURL + whitelabel + '/login.webp);' : ''">
  <main class="form-register">
    <form class="form-shadow">
      <div class="container justify-content-center">
        <div class="row justify-content-center">
          <div class="text-center mt-4">
            <a href="https://cubos.com"> <img class="mb-4" src="assets/images/cubos_cube_rgb.svg" alt="" width="72" height="57"> </a>
            <div class="col-md-12 col mb-2">
              <h3 class="font-weight-bold ml-md-0 mx-auto text-center" i18n="@@ForbiddenHeader">Keine Rechte für diese Seite</h3>
              <h4 class="mt-md-1 ml-md-0 ml-4 text-center" i18n="@@ForbiddenText">
                Sie haben keine Rechte diese Seite aufzurufen. Bitte melden Sie sich mit einem anderen Benutzer an.
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center round">
        <div class="col-lg-10 col-md-12">
          <div class="form-group">
            <div class="row justify-content-center">
              <div class="col-md-12 col-lg-10 col-12">
                <div class="mb-1 text-center">
                  <br />
                  <button class="btn btn-yellow" id="back_to_login" (click)="navigateToLogin()" i18n="@@BackToLoginButton">Zurück zur Anmeldung</button>
                </div>
                <p class="mt-2 mb-3 text-center text-muted"><a href="https://www.cubos.com" style="text-decoration: none; color: #6c757d;">© {{currentYearLong()}} CUBOS Service GmbH</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </main>
</body>
